<template>

  <div class="bill-info">
     <KTCodePreview v-bind:title="''"
      > <template v-slot:preview
        > <b-card
          no-body
          class="full-width"
          >
          <div>

            <div
              class="wizard wizard-4"
              id="kt_wizard_v4_bill"
              data-wizard-state="step-first"
              data-wizard-clickable="true"
            >
               <!--begin: Wizard Nav-->
              <div
                class="wizard-nav wizard-nav-bg"
                style="border-radius: 0px"
              >

                <div class="wizard-steps">
                   <!-- Thông tin -->
                  <div
                    class="wizard-step"
                    data-wizard-type="step"
                    data-wizard-state="current"
                  >

                    <div class="wizard-wrapper p-2">

                      <div class="wizard-label">

                        <div class="wizard-title">Thông tin</div>

                      </div>

                    </div>

                  </div>
                   <!-- Lịch sử -->
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >

                    <div class="wizard-wrapper p-2">

                      <div class="wizard-label">

                        <div class="wizard-title">Lịch sử</div>

                      </div>

                    </div>

                  </div>
                   <!-- Tệp đính kèm -->
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >

                    <div class="wizard-wrapper p-2">

                      <div class="wizard-label">

                        <div class="wizard-title">Tệp đính kèm</div>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

              <div class="card card-custom card-shadowless rounded-top-0">
                 <b-skeleton-wrapper :loading="!renderComponent"
                  > <template #loading
                    >
                    <div class="card-body">
                       <b-row
                        > <b-col md="9"
                          >
                          <div class="mb-4 d-flex d-inline">
                             <b-skeleton
                              animation="wave"
                              width="18%"
                              class="mr-2"
                            ></b-skeleton
                            > <b-skeleton
                              animation="wave"
                              width="82%"
                            ></b-skeleton
                            >
                          </div>
                           <b-skeleton-table
                            :rows="4"
                            :columns="4"
                            :table-props="{ bordered: true, striped: true }"
                          ></b-skeleton-table
                          > <b-row
                            > <b-col md="4"
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > </b-col
                            > <b-col md="4"
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > </b-col
                            > <b-col md="4"
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > </b-col
                            > </b-row
                          > </b-col
                        > <b-col md="3"
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > </b-col
                        > </b-row
                      >
                    </div>
                     </template
                  >
                  <div class="card-body">

                    <div class="row">
                       <!-- Thông tin -->
                      <div class="col-xl-12">

                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                          data-wizard-state="current"
                        >
                           <b-row
                            class="col-md-12 mb-1 m-0 p-0"
                            v-if="mainModel.relatedBillNumber"
                            >
                            <div
                              class="alert-header"
                              style="width: 100%"
                            >
                               Trả hàng từ hóa đơn <span
                                class="text-primary"
                                style="cursor: pointer"
                                @click="linkToSaleBill(mainModel.relatedBillNumber)"
                                >{{ mainModel.relatedBillNumber }}</span
                              >.
                              <ul
                                style="
                                  padding-left: 15px;
                                  line-height: 20px;
                                  margin-top: 5px;
                                  list-style: circle;
                                "
                              >

                                <li v-show="totalOrderPaid > 0">
                                   Số tiền đã thanh toán từ đơn hàng #{{ saleBillModel.orderId }}:
                                  <span class="text-primary"
                                    > {{ convertPrice(totalOrderPaid) }} </span
                                  >
                                </li>

                                <li v-show="mainModel.paymentInfo.cashAmount > 0">
                                   Số tiền mặt đã thanh toán: <span class="text-primary"
                                    > {{ convertPrice(saleBillModel.cashAmount) }} </span
                                  >
                                </li>

                                <li v-show="saleBillModel.transferAmount > 0">
                                   Số tiền đã chuyển khoản: <span class="text-primary"
                                    > {{ convertPrice(saleBillModel.transferAmount) }} </span
                                  >
                                </li>

                                <li v-show="saleBillModel.creditAmount > 0">
                                   Số tiền quẹt thẻ: <span class="text-primary"
                                    > {{ convertPrice(saleBillModel.creditAmount) }} </span
                                  >
                                </li>

                                <li v-show="saleBillModel.installedMoneyAmount > 0">
                                   Số tiền đã trả góp: <span class="text-primary"
                                    > {{ convertPrice(saleBillModel.installedMoneyAmount) }} </span
                                  >
                                </li>

                              </ul>

                            </div>
                             </b-row
                          >
                          <BillAdjustmentEInvoiceLockAlert :adjustment-einvoice="mainModel.adjustmentEinvoice" />
                          <b-row class="col-md-12 mb-1 m-0 p-0"
                            > <b-col
                              md="9"
                              class="mb-2"
                              > <BillRefundProduct
                                :billModel="mainModel"
                                :is-independent="isIndependent"
                                :is-update="isUpdateRefund"
                              /> <b-row
                                > <b-col md="4"
                                  > <CustomerInfo
                                    :billData="mainModel"
                                    v-on:onUpdate="onUpdateCustomer"
                                    v-if="renderComponent"
                                  /> </b-col
                                > <b-col md="4"
                                  > <EmployeeInfo
                                    :storeId="mainModel.storeId"
                                    :billDataEmployeeInfo="mainModel.billEmployeeInfo"
                                    :billType="mainModel.billType"
                                  /> </b-col
                                > <b-col md="4"> <BillNote :billNote="mainModel.billNote" :billType="mainModel.billType" /> </b-col
                                > </b-row
                              > </b-col
                            > <b-col
                              md="3"
                              class="mb-2"
                              > <BillRefundCheckoutForm
                                :billModel="mainModel"
                                :saleBillModel="saleBillModel"
                                v-if="renderComponent"
                              /> </b-col
                            > </b-row
                          > <b-row class="col-md-12 mb-1 m-0 p-0"
                            > <b-container class="p-0"
                              >
                              <hr
                                class="hr-text"
                                data-content="Bút Toán"
                                style="font-weight: 600"
                              />
                               <b-row
                                > <b-col
                                  md="12"
                                  lg="12"
                                  sm="12"
                                  > <BillTransactions :billNumber="$route.query.billNumber" />
                                  </b-col
                                > </b-row
                              >
                              <div style="position: sticky; top: 200px">
                                 <b-row
                                  > <b-col
                                    > <b-button
                                      style="font-weight: 600; width: 70px; margin-right: 10px"
                                      variant="primary"
                                      size="sm"
                                      @click="onSubmit()"
                                      :disabled="onSubmiting || !mainModel.editable"
                                      >Lưu</b-button
                                    > <router-link
                                      to="/bills"
                                      tag="button"
                                      > <b-button
                                        tabindex="16"
                                        style="font-weight: 600; width: 70px"
                                        variant="secondary"
                                        size="sm"
                                        >Hủy</b-button
                                      > </router-link
                                    > </b-col
                                  > </b-row
                                >
                              </div>
                               </b-container
                            > </b-row
                          >
                        </div>

                      </div>
                       <!-- Lịch sử -->
                      <div class="col-xl-12">

                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                        >
                           <b-container class="bv-example-row"
                            > <b-table
                              :fields="historyFields"
                              :items="histories"
                              class="table-bordered table-hover col-md-6"
                              > <template v-slot:cell(updatedBy)="row"
                                >
                                <div class="d-flex flex-column">
                                   <strong>{{ row.item.createdByName }}</strong
                                  > <small class="text-muted">{{ row.item.createdAt }}</small
                                  >
                                </div>
                                 </template
                              > <template v-slot:cell(userAgent)="row"
                                >
                                <div class="d-flex flex-column">
                                   <span><strong>IP:</strong> {{ row.item.userIP }}</span
                                  > <span class="text-muted"
                                    > OS: {{ row.item.userAgent.osName }} </span
                                  > <span class="text-muted"
                                    > Browser: {{ row.item.userAgent.browserName }} </span
                                  >
                                </div>
                                 </template
                              > <template v-slot:cell(detail)="row"
                                >
                                <div
                                  class="orderCode"
                                  @click="openHistoryModal(row.item.id)"
                                  style="cursor: pointer; color: #3699ff; font-weight: 500"
                                >
                                   #{{ row.item.id }}
                                </div>
                                 </template
                              > <template v-slot:cell(action)="row"
                                > <b-badge
                                  :variant="
                                    row.item.action === 1
                                      ? 'warning'
                                      : row.item.action === 4
                                        ? 'info'
                                        : 'danger'
                                  "
                                  > {{
                                    row.item.action === 1
                                      ? 'Sửa hóa đơn'
                                      : row.item.action === 4
                                        ? 'Sửa ghi chú'
                                        : 'Xóa hóa đơn'
                                  }} </b-badge
                                > </template
                              > </b-table
                            > </b-container
                          >
                        </div>

                      </div>
                       <!-- Tệp đính kèm -->
                      <div class="col-xl-12">

                        <div
                          class="pb-5 full-width"
                          data-wizard-type="step-content"
                        >
                           <b-container class="bv-example-row"
                            > <b-row
                              >
                              <div class="w-100">
                                 <upload-file
                                  :model-id="mainModel.billNumber"
                                  :model-name="'bills'"
                                  :max-files="10"
                                  :max-file-size="5 * 1024 * 1024"
                                />
                              </div>
                               </b-row
                            > </b-container
                          >
                        </div>

                      </div>

                    </div>

                  </div>
                   </b-skeleton-wrapper
                >
              </div>

            </div>

          </div>
           <BillHistoryModal
            :show="showHistoryModal"
            :history-id="selectedHistoryId"
            @update:show="showHistoryModal = $event"
            @open-modal="handleOpenModalFromUrl"
          /> </b-card
        > </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import KTCodePreview from '@/view/content/CodeTab.vue'
  import KTWizard from '@/assets/js/components/wizard'
  import _uniq from 'lodash/uniq'
  import KTUtil from '@/assets/js/components/util'
  import ApiService from '@/core/services/api.service'
  import moment from 'moment'
  import apiCommonMixin from '@/view/mixins/api-common.mixins.js'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import { TIME_TRIGGER } from '@/utils/constants'
  import BillRefundCheckoutForm from '@/view/components/bills/BillRefundCheckoutForm.vue'
  import BillRefundProduct from '@/view/components/bills/BillRefundProduct.vue'
  import CustomerInfo from '@/view/components/customers/CustomerInfo.vue'
  import EmployeeInfo from '@/view/components/bills/EmployeeInfo.vue'
  import BillNote from '@/view/components/bills/BillNote.vue'
  import BillTransactions from '@/view/components/bills/BillTransactions.vue'
  import BillHistoryModal from '@/view/components/bills/BillHistoryModal.vue'
  import BillAdjustmentEInvoiceLockAlert from '@/view/components/bills/BillAdjustmentEInvoiceLockAlert.vue'
  import { makeToastFaile, makeToastSuccess, cloneDeep, convertPrice } from '@/utils/common'
  import { logBillPaymentDebug, getFirstPaymentRefId, getFirstPaymentRow } from '@/utils/billPaymentDebug'
  import { ITEM_TYPE, AMOUNT_TYPE, PRODUCT_TYPE, PAYMENT_TYPE } from '@/utils/enum'
  import UploadFile from '@/view/modules/upload-v2/Upload.vue'
  import sortListBillItem from '../../../components/bills/helpers/sortListBillItem.js'
  import {
    appendStackAmountsIfNeeded,
    hydrateSplitAmountsFromApi,
  } from '@/utils/voucherDiscountStack'
  import { normalizePromotionLabelsFromHydrate } from '@/utils/discountProgramDisplay'

  export default {
    mixins: [apiCommonMixin],
    data() {
      return {
        mainModel: {
          id: null,
          billNumber: null,
          relatedBillNumber: null,
          billType: 3,
          adjustmentEinvoice: null,
          storeId: null,
          storeName: '',
          orderId: null,
          discountType: 1,
          discountAmount: 0,
          couponCode: '',
          billItems: [],
          customerModel: {
            customerId: null,
            customerName: '',
            customerMobile: '',
            customerEmail: '',
            customerAddress: '',
            customerCity: '',
            customerDistrict: '',
            customerWard: '',
            customerNote: '',
            customerPoint: 0,
            customerType: 1,
            customerStatus: 1,
            customerCreatedAt: '',
          },
          employeeModel: {
            employeeId: null,
            employeeName: '',
            employeeMobile: '',
            employeeEmail: '',
          },
          billEmployeeInfo: {
            saleId: null,
            saleName: '',
            technicalId: null,
            technicalName: '',
            cashierId: null,
            cashierName: '',
            accessoryStaffId: null,
            accessoryStaffName: '',
            managerId: null,
            managerName: '',
            assistantId: null,
            assistantName: '',
            customerReceptionId: null,
            customerReceptionName: '',
            shipperId: null,
            shipperName: '',
          },
          billNote: {
            customerNote: '',
            saleNote: '',
            warrantyNote: '',
          },
          vatInvoice: {
            vatCompanyType: 1,
            taxCode: '',
            companyAddress: '',
            companyName: '',
            email: '',
          },
          paymentInfo: {
            //tiền mặt
            cashAmount: 0,
            cashAccountantName: '',
            cashAccountId: null,
            //chuyển khoản
            transferAmount: 0,
            transferAccountantName: '',
            transferAccountantId: null,
            transferReferenceCode: '',
            // phí trả hàng
            refundFee: 0,
          },
          transfer: [],
          cash: [],
        },
        saleBillModel: {
          orderId: null,
          cashAmount: 0,
          transferAmount: 0,
          creditAmount: 0,
          installedMoneyAmount: 0,
          moneyPaid: 0,
          moneyTransfered: 0,
          moneyCredit: 0,
          moneyInstallment: 0,
        },
        renderComponent: false,
        onSubmiting: false,
        historyFields: [
          {
            key: 'updatedBy',
            label: 'Người thao tác',
            thStyle: { textAlign: 'center', width: '20%' },
          },
          {
            key: 'action',
            label: 'Hành động',
            sortable: false,
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '30%',
            },
          },
          {
            key: 'userAgent',
            label: 'Thông tin thiết bị',
            sortable: false,
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '30%',
            },
          },
          {
            key: 'detail',
            label: 'Chi tiết',
            sortable: false,
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          },
        ],
        histories: [],
        showHistoryModal: false,
        selectedHistoryId: null,
      }
    },
    components: {
      KTCodePreview,
      BillRefundProduct,
      BillRefundCheckoutForm,
      CustomerInfo,
      EmployeeInfo,
      BillNote,
      BillTransactions,
      BillHistoryModal,
      UploadFile,
      BillAdjustmentEInvoiceLockAlert,
    },
    computed: {
      hasAdjustmentEInvoiceLock() {
        const adj = this.mainModel && this.mainModel.adjustmentEinvoice
        return Boolean(adj && adj.status)
      },
      totalOrderPaid() {
        return (
          this.saleBillModel.moneyPaid +
          this.saleBillModel.moneyTransfered +
          this.saleBillModel.moneyCredit +
          this.saleBillModel.moneyInstallment
        )
      },
      // Phiếu trả hàng độc lập = không tham chiếu hóa đơn bán gốc.
      isIndependent() {
        return !this.mainModel.relatedBillNumber
      },
      // Đang cập nhật hóa đơn trả (đã có billNumber) -> khóa sửa IMEI.
      isUpdateRefund() {
        return Boolean(this.mainModel.billNumber)
      },
    },
    async mounted() {
      const title = this.$route.query.billNumber
        ? 'Cập nhật hóa đơn trả hàng'
        : 'Thêm mới hóa đơn trả hàng'
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Hóa đơn trả hàng', route: '/bills' },
        { title: 'Danh sách hóa đơn trả hàng', route: '/bills' },
        { title: title },
      ])
      this.initialTab()
      this.mainModel.relatedBillNumber = this.$route.query.relatedBillNumber
        ? this.$route.query.relatedBillNumber
        : null
      this.mainModel.billNumber = this.$route.query.billNumber ? this.$route.query.billNumber : null

      if (this.mainModel.relatedBillNumber) {
        this.getSaleBillByBillNumber()
      }
      if (this.mainModel.billNumber) {
        this.getBillByBillNumber()
        this.fetchBillHistory()
        this.checkModalFromUrl()
      }
      // Tạo phiếu trả hàng ĐỘC LẬP: không có hóa đơn bán gốc (vd dữ liệu từ PM cũ).
      // Không gọi getSaleBillByBillNumber; tự khởi tạo phiếu rỗng để form hiển thị & cho nhập tay.
      if (!this.mainModel.relatedBillNumber && !this.mainModel.billNumber) {
        this.initIndependentRefund()
      }
    },
    methods: {
      convertPrice,
      initialTab() {
        // Initialize form wizard
        const hashName = this.$route.hash ? this.$route.hash.split('#')[1] : ''

        this.hashName = hashName === 'attach' ? 'attach' : null

        const wizard = new KTWizard('kt_wizard_v4_bill', {
          startStep: hashName === 'attach' ? 3 : 1, // initial active step number
          clickableSteps: true, // allow step clicking
        })

        wizard.on('beforeNext', function (/*wizardObj*/) {})

        wizard.on('change', function (/*wizardObj*/) {
          setTimeout(() => {
            KTUtil.scrollTop()
          }, TIME_TRIGGER)
        })
      },
      onBack() {
        this.$router.push({
          name: 'list-refund-bill',
        })
      },
      // Khởi tạo phiếu trả hàng độc lập (không từ hóa đơn bán): mở form cho nhập tay.
      initIndependentRefund() {
        this.mainModel.relatedBillNumber = null
        this.mainModel.editable = true
        this.mainModel.billItems = []
        this.renderComponent = true
      },
      calcPaymentsAmount(items) {
        return items.reduce((result, item) => {
          const unMask = item.paymentAmount || 0
          return result + Number(unMask)
        }, 0)
      },
      linkToSaleBill: function (billNumber) {
        const { href } = this.$router.resolve({
          name: 'update-bill',
          params: { id: billNumber },
        })
        window.open(href, '_blank')
      },
      flattenFlexibleCombo(flexibleCombo) {
        const comboLines = flexibleCombo?.comboItems;
        if (!Array.isArray(comboLines)) {
          return [];
        }
        return comboLines.map((comboItem) => {
          return {
            id:
              comboItem.id != null && comboItem.id !== ''
                ? comboItem.id
                : null,
            productId: comboItem.productId,
            productPrice: comboItem.sellingPrice ?? comboItem.productPrice ?? 0,
            quantity: comboItem.quantity || 1,
            discountAmount: comboItem.discountAmount || 0,
            imeiCode: comboItem.imeiCode,
            productType: 1,
            accessoryGroupId: null,
            accessoryGroupCode: '',
            repurchasePrice: 0,
            isGiftTaken: true,
            note: '',
            gifts: [],
            attachs: [],
            discountType: AMOUNT_TYPE.MONEY,
            discountProgramId: null,
            issuedVat: true,
            flexibleComboId: flexibleCombo.flexibleComboId,
            flexibleComboItemId: comboItem.flexibleComboItemId,
          }
        })
      },
      convertBillItem(items) {
        return items.map((billItem) => {
          return {
            id: billItem.id || null,
            productId: billItem.productId,
            productPrice: billItem.sellingPrice,
            quantity: billItem.quantity || 1,
            discountAmount: billItem.discountAmount || 0,
            imeiCode: billItem.imeiCode,
            billItemType: billItem.itemType,
            accessoryGroupId: billItem.accessoryGroupId,
            accessoryGroupCode: billItem.accessoryGroupCode,
            repurchasePrice: 0,
            isGiftTaken: billItem.checked,
            note: billItem.note,
            gifts: [],
            attachs: [],
            discountType: billItem.discountType,
            discountProgramId: null,
            belongBillDetailId: billItem.belongBillDetailId,
            checked: billItem.checked,
          }
        })
      },
      isValidImeiCode(billItems) {
        return billItems.every((item) => {
          if (item.productType !== PRODUCT_TYPE.PRODUCT_IMEI) {
            return true
          }

          return item.imeiCode && item.imeiCode.trim()
        })
      },
      setBillItems() {
        const mainItems = this.mainModel.billItems.filter(
          (billItem) => billItem.itemType === ITEM_TYPE.MAIN && !billItem.flexibleComboId,
        )
        const flexibleComboBillItems = this.mainModel.billItems.filter(
          (billItem) => billItem.itemType === ITEM_TYPE.MAIN && billItem.flexibleComboId,
        )
        const giftItems = this.mainModel.billItems.filter(
          (item) => item.itemType === ITEM_TYPE.GIFT,
        )
        const attachItems = this.mainModel.billItems.filter(
          (item) => item.itemType === ITEM_TYPE.ATTACH,
        )

        const giftItemFormated = this.convertBillItem(giftItems)
        const attachItemFormated = this.convertBillItem(attachItems)

        const mainProductItems = mainItems.map((billItem) => {
          const gifts = giftItemFormated.filter(
            (giftItem) => giftItem.belongBillDetailId === billItem.id,
          )
          const attachs = attachItemFormated.filter(
            (attchItem) => attchItem.belongBillDetailId === billItem.id,
          )

          return appendStackAmountsIfNeeded(
            {
              id: billItem.id || null,
              productId: billItem.productId,
              productPrice: billItem.sellingPrice || 0,
              quantity: billItem.quantity || 1,
              discountAmount: billItem.discountAmount || 0,
              imeiCode: billItem.imeiCode,
              billItemType: billItem.itemType,
              accessoryGroupId: billItem.accessoryGroupId,
              accessoryGroupCode: billItem.accessoryGroupCode,
              repurchasePrice: 0,
              isGiftTaken: billItem.checked,
              note: billItem.note,
              gifts: gifts,
              attachs: attachs,
              discountType: billItem.discountType,
              discountProgramId: billItem.discountProgramId,
              issuedVat: billItem.isGetVat,
              merchantId: billItem.merchantId || 1,
              voucherId: billItem.voucherId || null,
              voucherDetailId: billItem.voucherDetailId || null,
              voucherCode: billItem.voucherCode || null,
            },
            billItem,
          )
        })
        let flexibleComboProductItems = []
        flexibleComboBillItems.forEach((flexibleComboBillItem) => {
          const flexibleComboTransformed = this.flattenFlexibleCombo(flexibleComboBillItem)
          flexibleComboProductItems = flexibleComboProductItems.concat(flexibleComboTransformed)
        })
        return mainProductItems.concat(flexibleComboProductItems)
      },
      setBillData() {
        logBillPaymentDebug('RefundInfo', this.mainModel, 'setBillData')
        const billItems = this.setBillItems()
        return {
          id: this.mainModel.id,
          billNumber: this.mainModel.billNumber || null,
          relatedBillNumber: this.mainModel.relatedBillNumber,
          isIndependent: this.isIndependent,
          storeId: this.mainModel.storeId,
          //khach hang
          customerMobile: this.mainModel.customerModel.customerMobile.trim(),
          customerName: this.mainModel.customerModel.customerName.trim(),
          customerAddress: this.mainModel.customerModel.customerAddress,
          customerCity: this.mainModel.customerModel.customerCity,
          customerDistrict: this.mainModel.customerModel.customerDistrict,
          customerWard: this.mainModel.customerModel.customerWard,
          customerLastName: this.mainModel.customerModel.customerLastName,
          customerAppellation: this.mainModel.customerModel.customerAppellation,
          //nhan vien
          saleId: this.mainModel.billEmployeeInfo.saleId,
          technicalId: this.mainModel.billEmployeeInfo.technicalId,
          cashierId: this.mainModel.billEmployeeInfo.cashierId,
          managerId: this.mainModel.billEmployeeInfo.managerId,
          assistantId: this.mainModel.billEmployeeInfo.assistantId,
          //ghi chu
          customerNote: this.mainModel.billNote.customerNote,
          saleNote: this.mainModel.billNote.saleNote,
          // payment
          transfer: this.mainModel.transfer,
          cash: this.mainModel.cash,
          refundFee: this.mainModel.paymentInfo.refundFee,
          //tien mat
          cashAmount: this.calcPaymentsAmount(this.mainModel.cash),
          cashAccountId: getFirstPaymentRefId(this.mainModel.cash),
          cashAccountCode: null,
          //chuyen khoan
          transferAmount: this.calcPaymentsAmount(this.mainModel.transfer),
          transferAccountID: getFirstPaymentRefId(this.mainModel.transfer),
          transferAccountCode: getFirstPaymentRow(this.mainModel.transfer)?.paymentCode,
          transferReferenceCode: getFirstPaymentRow(this.mainModel.transfer)?.paymentCode,
          billType: this.mainModel.billType,
          billItems,
        }
      },
      onCreateBill(payload) {
        ApiService.post('v1/bills/refund', payload)
          .then(({ data }) => {
            makeToastSuccess(data.message)
            this.onBack()
          })
          .catch((error) => {
            this.onSubmiting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
      },
      onUpdateBill(payload) {
        ApiService.put(`v1/bills/refund`, payload)
          .then(({ data }) => {
            makeToastSuccess(data.message)
            this.onBack()
          })
          .catch((response) => {
            this.onSubmiting = false
            const message = response?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
      },
      onSubmit() {
        this.onSubmiting = true
        logBillPaymentDebug('RefundInfo', this.mainModel, 'onSubmit')

        if (!this.mainModel.storeId) {
          this.onSubmiting = false
          return makeToastFaile('Vui lòng chọn cửa hàng!')
        }

        if (!this.mainModel.billItems.length) {
          this.onSubmiting = false
          return makeToastFaile('Bạn chưa chọn sản phẩm nào')
        }

        if (!this.isValidImeiCode(this.mainModel.billItems)) {
          this.onSubmiting = false
          return makeToastFaile('Vui lòng nhập mã IMEI cho sản phẩm IMEI')
        }

        const billData = this.setBillData()
        if (this.mainModel.id) {
          this.onUpdateBill(billData)
        } else {
          this.onCreateBill(billData)
        }
      },
      onUpdateCustomer(customerInfo) {
        this.mainModel.customerModel = cloneDeep(customerInfo)
      },
      combineFlexibleCombo(billItems) {
        const flexibleComboIds = _uniq(
          billItems.map((flexibleComboBillItem) => flexibleComboBillItem.flexibleComboId),
        )
        return flexibleComboIds.map((flexibleComboId) => {
          const flexibleComboItems = billItems.filter(
            (billItem) => billItem.flexibleComboId === flexibleComboId,
          )
          let comboName = ''
          if (flexibleComboItems.length) {
            comboName = flexibleComboItems[0].flexibleComboName
          }
          const comboItems = flexibleComboItems.map((flexibleComboItem) => {
            return {
              id: flexibleComboItem.id,
              productCode: flexibleComboItem.productCode ? flexibleComboItem.productCode : '',
              productName: flexibleComboItem.productName ? flexibleComboItem.productName : '',
              quantity: flexibleComboItem.quantity,
              productId: flexibleComboItem.productId,
              productPrice: flexibleComboItem.productPrice ? flexibleComboItem.productPrice : 0,
              sellingPrice: flexibleComboItem.productPrice ? flexibleComboItem.productPrice : 0,
              productType: PRODUCT_TYPE.PRODUCT,
              discountAmount: flexibleComboItem.discountAmount,
              productComboPrice: 0,
              productComboRate: 0,
              productVatAmount: flexibleComboItem.productVatAmount,
              productNameVat: flexibleComboItem.productNameVat
                ? flexibleComboItem.productNameVat
                : '',
              listedPrice: flexibleComboItem.productPrice ? flexibleComboItem.productPrice : 0,
              flexibleComboItemId: flexibleComboItem.flexibleComboItemId ?? null,
            }
          })
          const flexibleComboPrice = comboItems.reduce((result, product) => {
            result += product.productPrice * product.quantity - product.discountAmount
            return result
          }, 0)
          return {
            id: flexibleComboId,
            productId: flexibleComboId,
            productName: comboName,
            productCode: '',
            productNameVat: '',
            productNote: '',
            productType: PRODUCT_TYPE.PRODUCT_COMBO,
            quantity: 1,
            productPrice: flexibleComboPrice,
            imeiCode: '',
            totalPrice: flexibleComboPrice,
            discount: 0,
            discountType: AMOUNT_TYPE.PERCENT,
            comboItems: comboItems,
            itemType: ITEM_TYPE.MAIN,
            checked: true,
            accessoryGroupId: null,
            accessoryGroupCode: '',
            repurchasePrice: 0,
            belongBillDetailId: null,
            note: '',
            listAccessoryPromotion: [],
            listProductPromotion: [],
            issuedVat: true,
            sellingPrice: flexibleComboPrice,
            sellingPriceMask: flexibleComboPrice,
            listedPrice: flexibleComboPrice,
            flexibleComboId: flexibleComboId,
          }
        })
      },
      getSaleBillByBillNumber() {
        ApiService.get(`v1/bills/${this.mainModel.relatedBillNumber}`).then(async (response) => {
          const dataRes = response.data.data
          const {
            saleNote,
            customerNote,
            warrantyNote,
            customerId,
            discountAmount,
            discountType,
            customerShipFee,
            codeShip,
            cashAmount,
            transferAmount,
            creditAmount,
            installedMoneyAmount,
            depositAmount,
            transferFromOrder,
            moneyCredit,
            moneyInstallment,
            pointToMoney,
            subtractPoint,
            billItems,
            createdAt,
            customerAppellation,
          } = dataRes
          this.mainModel.billNote.warrantyNote = warrantyNote
          this.mainModel.billNote.saleNote = saleNote
          this.mainModel.billNote.customerNote = customerNote
          this.mainModel.customerModel.customerId = customerId
          this.mainModel.customerModel.customerMobile = dataRes.customerPhone
          this.mainModel.customerModel.customerAddress = dataRes.customerAddress
          this.mainModel.customerModel.customerName = dataRes.customerName
          this.mainModel.customerModel.customerCity = dataRes.customerCity
          this.mainModel.customerModel.customerWard = dataRes.customerWard
          this.mainModel.customerModel.customerDistrict = dataRes.customerDistrict
          this.mainModel.customerModel.totalPoint = dataRes.customerPoint
          this.mainModel.customerModel.customerAppellation = customerAppellation
          this.mainModel.discountAmount = discountAmount ? discountAmount : 0
          this.mainModel.discountType = discountType
          this.mainModel.codeShip = codeShip
          this.mainModel.customerShipFee = customerShipFee ? customerShipFee : 0
          this.saleBillModel.cashAmount = cashAmount
          this.saleBillModel.transferAmount = transferAmount
          this.saleBillModel.creditAmount = creditAmount
          this.saleBillModel.installedMoneyAmount = installedMoneyAmount
          this.saleBillModel.orderId = dataRes.orderId
          this.saleBillModel.moneyTransfered = transferFromOrder
          this.saleBillModel.moneyPaid = depositAmount
          this.saleBillModel.moneyCredit = moneyCredit
          this.saleBillModel.moneyInstallment = moneyInstallment
          this.saleBillModel.totalAmountPoint = pointToMoney
          this.saleBillModel.subtractPoint = subtractPoint
          this.mainModel.billNote.customerNote = dataRes.customerNote
          this.mainModel.billNote.saleNote = dataRes.saleNote
          this.mainModel.billNote.warrantyNote = dataRes.warrantyNote
          this.mainModel.editable = true
          this.mainModel.billCreatedAt = createdAt
          const flexibleComboBillItems = billItems.filter((billItem) => billItem.flexibleComboId)
          const normalBillItems = billItems.filter((billItem) => !billItem.flexibleComboId)
          const flexibleComboItems = this.combineFlexibleCombo(flexibleComboBillItems)
          this.mainModel.billItems = normalBillItems.map((billItem) => {
            const row = {
              id: billItem.id,
              productId: billItem.productId,
              productName: billItem.productName,
              productNameVat: billItem.productNameVat,
              barCode: billItem.barCode,
              imageUrl: billItem.imageUrl,
              productCode: billItem.productCode,
              sellingPrice: billItem.productPrice,
              sellingPriceMask: billItem.productPrice,
              productType: billItem.productType,
              quantity: billItem.quantity,
              imeiCode: billItem.imeiCode,
              totalPrice: billItem.quantity * billItem.productPrice - billItem.discountAmount,
              discountAmount:
                billItem.discountUnitAmount != null
                  ? billItem.discountUnitAmount
                  : billItem.discountAmount,
              comboItems: billItem.listProductInCombo,
              itemType: billItem.billItemType,
              repurchasePrice: billItem.repurchasePrice ? billItem.repurchasePrice : 0,
              accessoryGroupId: billItem.accessoryGroupId ? billItem.accessoryGroupId : '',
              accessoryGroupCode: billItem.accessoryGroupCode ? billItem.accessoryGroupCode : '',
              note: billItem.note,
              belongBillDetailId: billItem.belongBillDetailId,
              listAccessoryPromotion: billItem.listProductPromotion,
              quantityInStock: billItem.quantityInStock,
              discountType: parseInt(billItem.discountType),
              discountProgramId: billItem.discountProgramId,
              isGetVat: billItem.issuedVat === 1 ? true : false,
              disabledByInstallmentProgram: this.applyInstallmentProgram ? true : false,
              isInstallmentProgramProduct: this.applyInstallmentProgram ? true : false,
              listedPrice: billItem.listedPrice || 0,
              flexibleComboId: billItem.flexibleComboId || null,
              voucherId: billItem.voucherId || null,
              voucherDetailId: billItem.voucherDetailId || null,
              voucherCode: billItem.voucherCode || null,
              voucherCumluativeValues: billItem.cumluativeValues || [],
              promotionProgramCode: billItem.promotionProgramCode || '',
              promotionProgramName: billItem.promotionProgramName || '',
            }
            hydrateSplitAmountsFromApi(row, billItem.discountProgramAmount, billItem.voucherAmount)
            normalizePromotionLabelsFromHydrate(row, billItem)
            return row
          })
          this.mainModel.billItems = this.mainModel.billItems.concat(flexibleComboItems)
          this.mainModel.billItems = sortListBillItem(this.mainModel.billItems)
          setTimeout(() => {
            this.renderComponent = true
          }, TIME_TRIGGER)
        })
      },
      getBillByBillNumber() {
        ApiService.get(`v1/bills/${this.mainModel.billNumber}`).then(async (response) => {
          const dataRes = response.data.data
          const {
            id,
            storeId,
            storeName,
            saleNote,
            customerNote,
            warrantyNote,
            customerId,
            cashAmount,
            cashAccountId,
            cashAccName,
            cashAccountCode,
            transferAmount,
            transferAccountId,
            transferAccName,
            transferAccountCode,
            transferReferenceCode,
            billItems,
            editable,
            payments,
            returnFee,
            createdAt,
            customerAppellation,
          } = dataRes
          this.mainModel.id = id
          this.mainModel.storeId = storeId
          this.mainModel.storeName = storeName
          this.mainModel.billNote.warrantyNote = warrantyNote
          this.mainModel.billNote.saleNote = saleNote
          this.mainModel.billNote.customerNote = customerNote
          this.mainModel.customerModel.customerId = customerId
          this.mainModel.customerModel.customerMobile = dataRes.customerPhone
          this.mainModel.customerModel.customerAddress = dataRes.customerAddress
          this.mainModel.customerModel.customerName = dataRes.customerName
          this.mainModel.customerModel.customerCity = dataRes.customerCity
          this.mainModel.customerModel.customerWard = dataRes.customerWard
          this.mainModel.customerModel.customerDistrict = dataRes.customerDistrict
          this.mainModel.customerModel.totalPoint = dataRes.customerPoint
          this.mainModel.customerModel.customerAppellation = customerAppellation
          this.mainModel.billEmployeeInfo.saleId = dataRes.saleId
          this.mainModel.billEmployeeInfo.saleName = dataRes.saleName
          this.mainModel.billEmployeeInfo.technicalId = dataRes.technicalId
          this.mainModel.billEmployeeInfo.technicalName = dataRes.techName
          this.mainModel.billEmployeeInfo.cashierId = dataRes.cashierId
          this.mainModel.billEmployeeInfo.cashierName = dataRes.cashierName
          this.mainModel.billEmployeeInfo.managerId = dataRes.managerId
          this.mainModel.billEmployeeInfo.managerName = dataRes.managerName
          this.mainModel.billEmployeeInfo.assistantId = dataRes.assistantId
          this.mainModel.billEmployeeInfo.assistantName = dataRes.assistantName
          this.mainModel.paymentInfo.cashAmount = cashAmount
          this.mainModel.paymentInfo.cashAccountId = cashAccountId
          this.mainModel.paymentInfo.cashAccountantName = cashAccName
          this.mainModel.paymentInfo.cashAccountCode = cashAccountCode
          this.mainModel.paymentInfo.transferAmount = transferAmount
          this.mainModel.paymentInfo.transferAccountantId = transferAccountId
          this.mainModel.paymentInfo.transferAccountantName = transferAccName
          this.mainModel.paymentInfo.transferAccountCode = transferAccountCode
          this.mainModel.paymentInfo.transferReferenceCode = transferReferenceCode
          this.mainModel.paymentInfo.refundFee = returnFee
          this.mainModel.billNote.customerNote = dataRes.customerNote
          this.mainModel.billNote.saleNote = dataRes.saleNote
          this.mainModel.adjustmentEinvoice = dataRes.adjustmentEinvoice || null
          // BE đã fold adjustmentEinvoice + permission BILL_ALLOW_EDIT_WHEN_EINVOICE_EXISTS vào `editable`.
          this.mainModel.editable = editable
          this.mainModel.billCreatedAt = createdAt
          this.mainModel.transfer = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.TRANSFER,
          )
          this.mainModel.cash = payments.filter((item) => item.paymentType === PAYMENT_TYPE.CASH)
          const flexibleComboBillItems = billItems.filter((billItem) => billItem.flexibleComboId)
          const normalBillItems = billItems.filter((billItem) => !billItem.flexibleComboId)
          const flexibleComboItems = this.combineFlexibleCombo(flexibleComboBillItems)
          this.mainModel.billItems = normalBillItems.map((billItem) => {
            const row = {
              id: billItem.id,
              productId: billItem.productId,
              productName: billItem.productName,
              imageUrl: billItem.imageUrl,
              productNameVat: billItem.productNameVat,
              barCode: billItem.barCode,
              productCode: billItem.productCode,
              sellingPrice: billItem.productPrice,
              sellingPriceMask: billItem.productPrice,
              productType: billItem.productType,
              quantity: billItem.quantity,
              imeiCode: billItem.imeiCode,
              totalPrice: billItem.quantity * billItem.productPrice - billItem.discountAmount,
              discountAmount:
                billItem.discountUnitAmount != null
                  ? billItem.discountUnitAmount
                  : billItem.discountAmount,
              comboItems: billItem.listProductInCombo,
              itemType: billItem.billItemType,
              repurchasePrice: billItem.repurchasePrice ? billItem.repurchasePrice : 0,
              accessoryGroupId: billItem.accessoryGroupId ? billItem.accessoryGroupId : '',
              accessoryGroupCode: billItem.accessoryGroupCode ? billItem.accessoryGroupCode : '',
              note: billItem.note,
              belongBillDetailId: billItem.belongBillDetailId,
              listAccessoryPromotion: billItem.listProductPromotion,
              quantityInStock: billItem.quantityInStock,
              storeId: storeId,
              discountType: parseInt(billItem.discountType),
              discountProgramId: billItem.discountProgramId,
              isGetVat: billItem.issuedVat === 1 ? true : false,
              disabledByInstallmentProgram: this.applyInstallmentProgram ? true : false,
              isInstallmentProgramProduct: this.applyInstallmentProgram ? true : false,
              listedPrice: billItem.listedPrice || 0,
              flexibleComboId: billItem.flexibleComboId || null,
              voucherId: billItem.voucherId || null,
              voucherDetailId: billItem.voucherDetailId || null,
              voucherCode: billItem.voucherCode || null,
              voucherCumluativeValues: billItem.cumluativeValues || [],
              promotionProgramCode: billItem.promotionProgramCode || '',
              promotionProgramName: billItem.promotionProgramName || '',
            }
            hydrateSplitAmountsFromApi(row, billItem.discountProgramAmount, billItem.voucherAmount)
            normalizePromotionLabelsFromHydrate(row, billItem)
            return row
          })
          this.mainModel.billItems = this.mainModel.billItems.concat(flexibleComboItems)
          this.mainModel.billItems = sortListBillItem(this.mainModel.billItems)
          setTimeout(() => {
            this.renderComponent = true
          }, TIME_TRIGGER)
        })
      },
      openHistoryModal(historyId) {
        this.selectedHistoryId = historyId
        this.showHistoryModal = true
      },
      handleOpenModalFromUrl(historyId) {
        this.selectedHistoryId = historyId
        this.showHistoryModal = true
      },
      checkModalFromUrl() {
        const urlParams = new URLSearchParams(window.location.search)
        const modal = urlParams.get('modal')
        const historyId = urlParams.get('id')

        if (modal === 'bill-history' && historyId) {
          this.openHistoryModal(historyId)
        }
      },
      fetchBillHistory: async function () {
        const params = {
          //  loại hóa đơn
          type: 2,
        }
        await ApiService.query('/v1/histories/getByReferenceId/' + this.mainModel.billNumber, {
          params,
        }).then((res) => {
          const resData = res.data.data || []
          this.histories = resData.map((data) => {
            return {
              id: data.id,
              type: data.type,
              referenceId: data.referenceId,
              action: data.action,
              originalValue: data.originalValue,
              newValue: data.newValue,
              updatedBy: data.updatedBy,
              userAgent: data.userAgent,
              userIP: data.userIP,
              createdByName: data.createdByName,
              createdAt: moment(String(data.createdAt)).format('DD/MM/YYYY HH:mm'),
              updatedAt: moment(data.updatedAt).format('DD/MM HH:mm'),
            }
          })
        })
      },
    },
  }
</script>

<style lang="scss">
  .bill-info {
  .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
    flex: 0 0 calc(15% - 0.25rem);
  }

  @media (max-width: 1399.98px) {
    .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
      flex: 0 0 calc(17% - 0.25rem);
    }
  }

  .wizard-nav-bg {
    background-color: #f7f7f7;
    border-radius: 5px 5px 0px 0px;
  }

  .alert-header {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }
  .box {
    background: black;
    border-radius: 4px;
    padding-bottom: 100%;
  }
  .headerTable {
    color: rgb(24, 28, 50);
    text-align: center;
  }

  .form-group label {
    font-weight: 500;
  }

  .textExcessCash {
    font-weight: 500;
    color: rgba(71, 71, 255, 0.87);
  }
  .row-center-vertical {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .textPoint {
    font-size: 14px;
    font-weight: 500;
  }
  .textFinal {
    font-weight: 500;
    color: brown;
  }
  .textTitlePayment {
    font-weight: 500;
    font-size: 14px;
  }

  .textPayment {
    font-size: 16px;
    font-weight: 500;
    color: brown;
  }

  .no-side {
    padding-left: 0px;
    padding-right: 0px;
  }
  .dropdown-custom {
    .btn-sm,
    .btn-group-sm > .btn {
      padding: 1px 2px;
      background-color: transparent;
      border: none;
      border-radius: 3px;
    }
  }
}
</style>

<style lang="scss">
  @import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>

<style lang="scss">
  .upload-file {
  table {
    table-layout: fixed;
  }
  .dropbox {
    margin: auto;
    width: 70%;
    background: #f8f8f8;
    border-radius: 20px;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    left: 0px;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: #e8f5e9;
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
  .img-container {
    position: relative;
    display: inline-block;
    width: 80px;
    margin: 0px 10px;
  }
  .preview-img {
    max-width: 80px;
    padding: 10px;
    object-fit: contain;
    border: 1px solid #eeecff;
    border-radius: 5px;
  }
  .preview-img-container {
    border: 2px dashed #eeecff;
    padding: 2rem 1rem;
  }

  .preview-box {
    display: inline-block;
  }
  .close {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 15px;
  }
  .remove {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 15px;
  }
  .cancel {
    color: #545454;
    text-decoration: none;
  }
}
</style>

